import React                               from "react";
import {FloatingCenteredDiv, ColumnLayout} from "./styled";
import Flower                              from 'material-ui/svg-icons/maps/local-florist';

export default class InitScreen extends React.Component {
    constructor() {
        super();
        this.resizeTimeout;
        this.state = {
            iconSizeUnit: null
        }
    }

    resizeThrottler = () => {
        if (!this.resizeTimeout) {
            this.resizeTimeout = setTimeout(() => {
                this.resizeTimeout = null;
                this.measure();
            }, 66);
        }
    }

    measure() {
        this.setState(
            {iconSizeUnit: (window.innerHeight < window.innerWidth) ? 'vh' : 'vw'})
    }

    componentDidMount() {
        window.addEventListener("resize", this.resizeThrottler);
        this.measure()
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resizeThrottler);
    }

    render = () => <FloatingCenteredDiv>
        <ColumnLayout style={{alignItems: 'center'}}>
            <Flower style={{width: `20${this.state.iconSizeUnit}`, height: `20${this.state.iconSizeUnit}`, opacity: 0.5}}></Flower>
            <br/>
            <div>Loading...</div>
        </ColumnLayout>
    </FloatingCenteredDiv>
}


// WEBPACK FOOTER //
// ./src/components/initScreen.jsx